
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agendar",
      function () {
        return require("private-next-pages/agendar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agendar"])
      });
    }
  